import React from "react";

// Bloque de precio del presupuesto, con 3 estilos visuales seleccionables.
// Port directo de la funcion PrecioBlock del HTML standalone.
// Estilos disponibles: "ejecutivo" (numerado), "sello" (hero + total grande), "banca" (tabla + total).

const IconUnidad = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h.01M15 17h.01" />
  </svg>
);
const IconAmenity = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 22h20M4 22V10l8-6 8 6v12M9 22v-6h6v6" />
  </svg>
);
const IconEmpleado = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5 21c0-3.5 3-6 7-6s7 2.5 7 6" />
  </svg>
);

export default function PrecioBlock({
  estilo,
  c,
  total,
  promoTotal,
  fmt,
  totalUnidades,
  totalEmpleados,
}) {
  const tieneTotal = `${fmt(total)}`;
  const tienePromo = c.aplicaPromo;
  const nAmenities = c.amenities.length;

  const servicios = [
    {
      n: totalUnidades,
      label: totalUnidades === 1 ? "Unidad" : "Unidades",
      sub: "administración integral",
      Icon: IconUnidad,
    },
    {
      n: nAmenities,
      label: nAmenities === 1 ? "Amenity" : "Amenities",
      sub: "gestión y mantenimiento",
      Icon: IconAmenity,
    },
    {
      n: totalEmpleados,
      label: totalEmpleados === 1 ? "Empleado" : "Empleados",
      sub: "liquidación de sueldos",
      Icon: IconEmpleado,
    },
  ].filter((s) => s.n > 0);

  // ===== A · EJECUTIVO — Numerado: "1. Que incluye" + "2. Inversion mensual" =====
  if (estilo === "ejecutivo") {
    return (
      <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
        {/* Paso 1 — Servicios incluidos */}
        <div style={{ borderRadius: 6, overflow: "hidden", border: "1px solid var(--line)", background: "#fff" }}>
          <div style={{ padding: "10px 18px", background: "var(--blue-pale)", display: "flex", alignItems: "center", gap: 10, borderBottom: "1px solid var(--line)" }}>
            <span style={{ width: 22, height: 22, borderRadius: 999, background: "var(--blue)", color: "#fff", display: "grid", placeItems: "center", fontSize: "10pt", letterSpacing: "-0.02em" }}>1</span>
            <span style={{ fontSize: "10pt", letterSpacing: ".06em", color: "var(--blue-deep)", textTransform: "uppercase" }}>Qué incluye este servicio</span>
          </div>
          <div style={{ padding: "18px 22px", display: "grid", gridTemplateColumns: `repeat(${servicios.length}, 1fr)`, gap: 0 }}>
            {servicios.map((s, i) => (
              <div key={i} style={{ padding: "0 18px", borderLeft: i > 0 ? "1px solid var(--line)" : "none", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--blue-pale)", color: "var(--blue)", display: "grid", placeItems: "center" }}>
                  <div style={{ width: 18, height: 18 }}><s.Icon /></div>
                </div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 4 }}>
                  <div style={{ fontSize: "36pt", letterSpacing: "-0.045em", lineHeight: .85, color: "var(--blue)", fontVariantNumeric: "tabular-nums" }}>{s.n}</div>
                </div>
                <div style={{ fontSize: "12pt", letterSpacing: "-0.015em", color: "var(--ink)", lineHeight: 1.1 }}>{s.label}</div>
                <div style={{ fontSize: "9pt", color: "var(--ink-3)", lineHeight: 1.4 }}>{s.sub}</div>
              </div>
            ))}
          </div>
          <div style={{ padding: "10px 22px", borderTop: "1px solid var(--line)", background: "#FAFBFD", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "9.5pt", color: "var(--ink-2)" }}>
            <span>+ Plataforma 24/7 · App móvil · Asistente IA · Asambleas · Contabilidad</span>
            <span style={{ color: "var(--blue)", letterSpacing: ".06em", textTransform: "uppercase", fontSize: "8.5pt" }}>Onboarding bonificado</span>
          </div>
        </div>

        {/* Paso 2 — Inversion mensual */}
        <div style={{ borderRadius: 6, overflow: "hidden", border: "1px solid var(--blue)", background: "#fff" }}>
          <div style={{ padding: "10px 18px", background: "var(--blue)", color: "#fff", display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 22, height: 22, borderRadius: 999, background: "#fff", color: "var(--blue)", display: "grid", placeItems: "center", fontSize: "10pt", letterSpacing: "-0.02em" }}>2</span>
            <span style={{ fontSize: "10pt", letterSpacing: ".06em", textTransform: "uppercase" }}>Inversión mensual</span>
          </div>
          <div style={{ padding: "22px 26px", display: "grid", gridTemplateColumns: "1fr auto", gap: 24, alignItems: "center" }}>
            <div>
              <div style={{ fontSize: "11pt", color: "var(--ink-2)", lineHeight: 1.5 }}>
                Honorario único todo incluido para la administración integral de{" "}
                <b style={{ color: "var(--ink)" }}>{c.edificio}</b>.
              </div>
              <div style={{ marginTop: 8, fontSize: "9pt", color: "var(--ink-3)", letterSpacing: ".04em" }}>
                Pesos uruguayos · IVA incluido · Ajuste anual por IPC del INE
              </div>
            </div>
            <div style={{ textAlign: "right", borderLeft: "3px solid var(--blue)", paddingLeft: 22 }}>
              {tienePromo && (
                <div style={{ fontSize: "12pt", color: "var(--ink-3)", textDecoration: "line-through 1px", marginBottom: 2 }}>
                  {tieneTotal}
                </div>
              )}
              <div style={{ fontSize: "48pt", letterSpacing: "-0.045em", lineHeight: .9, color: "var(--blue)", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}>
                {tienePromo ? fmt(promoTotal) : tieneTotal}
              </div>
              <div style={{ fontSize: "11pt", color: "var(--ink-2)", marginTop: 2 }}>por mes</div>
            </div>
          </div>
          {tienePromo && (
            <div style={{ padding: "10px 22px", background: "var(--blue-pale)", borderTop: "1px solid var(--line)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "var(--blue-deep)", textTransform: "uppercase", letterSpacing: ".18em", fontSize: "8.5pt" }}>
                Promo de bienvenida
              </span>
              <span style={{ color: "var(--blue)", fontSize: "10.5pt" }}>
                {c.promoPorcentaje}% OFF · primeros {c.promoMeses} {c.promoMeses === 1 ? "mes" : "meses"} · ahorro {fmt(total - promoTotal)}/mes
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ===== B · SELLO — Hero + total prominente, jerarquia centrada =====
  if (estilo === "sello") {
    return (
      <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 0 }}>
        {/* Hero azul Habitia con numeros enormes */}
        <div style={{ background: "var(--blue)", color: "#fff", borderRadius: "6px 6px 0 0", padding: "22px 24px 20px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "repeating-linear-gradient(90deg, rgba(255,255,255,.05) 0 1px, transparent 1px 28px)", pointerEvents: "none" }} />
          <div style={{ position: "relative", textAlign: "center", fontSize: "9pt", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.78)", marginBottom: 14 }}>
            Tu edificio en números
          </div>
          <div style={{ position: "relative", display: "grid", gridTemplateColumns: `repeat(${servicios.length}, 1fr)`, gap: 0 }}>
            {servicios.map((s, i) => (
              <div key={i} style={{ padding: "0 14px", borderLeft: i > 0 ? "1px solid rgba(255,255,255,.22)" : "none", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                <div style={{ width: 30, height: 30, color: "rgba(255,255,255,.8)" }}><s.Icon /></div>
                <div style={{ fontSize: "50pt", letterSpacing: "-0.05em", lineHeight: .85, color: "#fff", fontVariantNumeric: "tabular-nums", marginTop: 2 }}>{s.n}</div>
                <div style={{ fontSize: "12pt", color: "#fff", letterSpacing: "-0.015em", marginTop: 4 }}>{s.label}</div>
                <div style={{ fontSize: "9pt", color: "rgba(255,255,255,.72)" }}>{s.sub}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Total — fondo blanco, numero grande en azul */}
        <div style={{ background: "#fff", border: "1px solid var(--blue)", borderTop: "none", borderRadius: "0 0 6px 6px", padding: "26px 28px 24px", textAlign: "center" }}>
          <div style={{ fontSize: "9pt", letterSpacing: ".22em", textTransform: "uppercase", color: "var(--ink-3)", marginBottom: 6 }}>
            Honorario único todo incluido
          </div>
          {tienePromo && (
            <div style={{ fontSize: "14pt", color: "var(--ink-3)", textDecoration: "line-through 1px", marginBottom: 2 }}>
              {tieneTotal} /mes
            </div>
          )}
          <div style={{ fontSize: "68pt", letterSpacing: "-0.05em", lineHeight: .88, color: "var(--blue)", fontVariantNumeric: "tabular-nums" }}>
            {tienePromo ? fmt(promoTotal) : tieneTotal}
            <span style={{ fontSize: "15pt", color: "var(--ink-3)", letterSpacing: 0, marginLeft: 6 }}>/mes</span>
          </div>
          <div style={{ fontSize: "10pt", color: "var(--ink-2)", marginTop: 6, letterSpacing: ".04em" }}>
            pesos uruguayos · IVA incluido · ajuste anual por IPC
          </div>
          {tienePromo && (
            <div style={{ marginTop: 16, display: "inline-flex", alignItems: "center", gap: 10, padding: "9px 18px", background: "var(--blue-pale)", color: "var(--blue-deep)", borderRadius: 999, fontSize: "10pt" }}>
              <span style={{ width: 7, height: 7, borderRadius: 999, background: "var(--blue)" }} />
              <b style={{ color: "var(--blue)" }}>Promo de bienvenida:</b> {c.promoPorcentaje}% OFF los primeros {c.promoMeses} {c.promoMeses === 1 ? "mes" : "meses"}
            </div>
          )}
        </div>
      </div>
    );
  }

  // ===== C · BANCA — Tabla limpia: lista de servicios + total destacado =====
  return (
    <div style={{ marginTop: 14, borderRadius: 6, overflow: "hidden", border: "1px solid var(--line)", background: "#fff" }}>
      {/* Header */}
      <div style={{ padding: "14px 24px", background: "var(--blue-deep)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: "8.5pt", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.65)" }}>
            Propuesta · Administración Integral
          </div>
          <div style={{ fontSize: "13pt", letterSpacing: "-0.015em", color: "#fff", marginTop: 2 }}>{c.edificio}</div>
        </div>
      </div>

      {/* Lista de servicios incluidos */}
      <div style={{ padding: "4px 0" }}>
        {servicios.map((s, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "56px 1fr auto", gap: 18, padding: "14px 24px", borderBottom: "1px solid var(--line)", alignItems: "center" }}>
            <div style={{ width: 44, height: 44, borderRadius: 8, background: "var(--blue-pale)", color: "var(--blue)", display: "grid", placeItems: "center" }}>
              <div style={{ width: 22, height: 22 }}><s.Icon /></div>
            </div>
            <div>
              <div style={{ fontSize: "12pt", letterSpacing: "-0.015em", color: "var(--ink)" }}>{s.label}</div>
              <div style={{ fontSize: "9.5pt", color: "var(--ink-3)", marginTop: 1 }}>{s.sub}</div>
            </div>
            <div style={{ fontSize: "32pt", letterSpacing: "-0.04em", lineHeight: .9, color: "var(--blue)", fontVariantNumeric: "tabular-nums" }}>{s.n}</div>
          </div>
        ))}
        <div style={{ display: "grid", gridTemplateColumns: "56px 1fr auto", gap: 18, padding: "12px 24px", alignItems: "center" }}>
          <div style={{ width: 44, height: 44, borderRadius: 8, background: "var(--blue-pale)", color: "var(--blue)", display: "grid", placeItems: "center" }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 22, height: 22 }}>
              <rect x="3" y="4" width="18" height="14" rx="2" />
              <path d="M3 9h18M7 14h4" />
            </svg>
          </div>
          <div>
            <div style={{ fontSize: "12pt", letterSpacing: "-0.015em", color: "var(--ink)" }}>Plataforma habitia 24/7</div>
            <div style={{ fontSize: "9.5pt", color: "var(--ink-3)", marginTop: 1 }}>app móvil, asistente IA, estado de cuenta y comprobantes</div>
          </div>
          <div style={{ fontSize: "10pt", color: "var(--blue)", letterSpacing: ".06em", textTransform: "uppercase" }}>Incluida</div>
        </div>
      </div>

      {/* Total destacado en azul */}
      <div style={{ background: "var(--blue)", color: "#fff", padding: "22px 26px", display: "grid", gridTemplateColumns: "1fr auto", gap: 24, alignItems: "center" }}>
        <div>
          <div style={{ fontSize: "9pt", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.78)", marginBottom: 4 }}>
            Honorario único · todo incluido
          </div>
          <div style={{ fontSize: "10.5pt", color: "rgba(255,255,255,.92)", lineHeight: 1.4, maxWidth: "40ch" }}>
            Onboarding bonificado y ajuste anual por IPC del INE.
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          {tienePromo && (
            <div style={{ fontSize: "12pt", color: "rgba(255,255,255,.55)", textDecoration: "line-through 1px", marginBottom: 2 }}>
              {tieneTotal} /mes
            </div>
          )}
          <div style={{ fontSize: "50pt", letterSpacing: "-0.045em", lineHeight: .9, color: "#fff", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}>
            {tienePromo ? fmt(promoTotal) : tieneTotal}
            <span style={{ fontSize: "13pt", color: "rgba(255,255,255,.7)", letterSpacing: 0, marginLeft: 4 }}>/mes</span>
          </div>
          <div style={{ fontSize: "9pt", color: "rgba(255,255,255,.6)", marginTop: 2, letterSpacing: ".04em" }}>
            pesos uruguayos · IVA incluido
          </div>
        </div>
      </div>

      {tienePromo && (
        <div style={{ background: "var(--blue-pale)", padding: "10px 26px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ color: "var(--blue-deep)", textTransform: "uppercase", letterSpacing: ".18em", fontSize: "8.5pt" }}>
            Promo de bienvenida
          </span>
          <span style={{ color: "var(--blue)", fontSize: "10.5pt" }}>
            {c.promoPorcentaje}% OFF · primeros {c.promoMeses} {c.promoMeses === 1 ? "mes" : "meses"} · ahorro {fmt(total - promoTotal)}/mes
          </span>
        </div>
      )}
    </div>
  );
}
